import React from "react";
import { useDropzone } from "react-dropzone";
import { FiUploadCloud } from "react-icons/fi";
import { GoAlert } from "react-icons/go";
import { AiFillCloseCircle } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { Controller } from "react-hook-form";

import Error from "../form/Error";

const CustomizeUploader = ({
  imageUrl,
  isMultiple,
  files,
  setFiles,
  imageUrls,
  warning,
  onDrop,
  error,
  isLogo,
  validations,
  control,
  field,
  setValue,
  selectedSection,
  max,
}) => {
  // Hooks
  console.log("files in customize uploader", files);
  const { t } = useTranslation();
  const maxFiles = max || 1;

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    multiple: isMultiple || false,
    onDrop: (acceptedFiles) => {
      const updatedFiles = acceptedFiles.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        })
      );
      setFiles(updatedFiles); // Update state with new files
      console.log("Updated files after selection:", updatedFiles);
    },
  });

  const isUploaderDisabled =  (imageUrls?.length || 0) + (files?.length || 0) >= maxFiles;
  
  // Filter out invalid entries before mapping
  const thumbs = files
    ?.filter((file) => file !== null && file !== undefined)
    .map((file, index) => (
      <div key={file?.name} className="mx-5">
        <div className="relative">
          <img
            className="inline-flex border-2 border-gray-100 w-24 max-h-24"
            src={file?.preview}
            alt={file?.name}
            style={isLogo ? { width: "200px", height: "60px" } : {}}
          />
          <span
            className="text-red-400 absolute text-2xl cursor-pointer"
            style={{ top: "-12px", right: "-10px" }}
            onClick={() => removeImageFile(index)}
          >
            <AiFillCloseCircle />
          </span>
        </div>
      </div>
    ));

  console.log("imageUrls in CustomizeUploader:", imageUrls);

  const displayServerImage = (imgUrl, index) => {
    if (!imgUrl) {
      console.warn("Empty or invalid server image URL at index:", index);
      return null;
    }
    console.log("Rendering server image:", imgUrl);
    return (
      <div className="relative mx-2">
        <img
          className="inline-flex border rounded-md border-gray-100 dark:border-gray-600 w-24 max-h-24 p-2"
          src={imgUrl}
          alt="product"
        />
        <span
          className="text-red-400 absolute text-2xl cursor-pointer"
          style={{ top: "-12px", right: "-10px" }}
          onClick={() => {
            setValue(`banners.${selectedSection.data?.index}.image`, null);
          }}
        >
          <AiFillCloseCircle />
        </span>
      </div>
    );
  };

  const removeImageFile = (index) => {
    setValue(`banners.${selectedSection.data?.index}.image`, null);
    const updatedFiles = [...files];
    updatedFiles.splice(index, 1);
    setFiles(updatedFiles);
    console.log("Updated files after removal:", updatedFiles);
  };

  const removeImageUrl = (index) => {
    console.log("Removing image at index:", index);
    console.log("Current imageUrls before removal:", imageUrls);

    const updatedImageUrls = [...imageUrls];
    updatedImageUrls.splice(index, 1);
    setFiles(updatedImageUrls);

    console.log("Updated imageUrls after removal:", updatedImageUrls);
  };

  return (
    <div className="w-full text-center">
      <Controller
        control={control}
        name={field}
        rules={validations}
        render={() => (
          <div
            className={`px-6 pt-5 pb-6 border-2 border-gray-300 dark:border-gray-600 border-dashed rounded-md cursor-pointer ${isUploaderDisabled ? 'opacity-50 cursor-not-allowed' : ''}`}
            {...(isUploaderDisabled ? {} : getRootProps())}
          >
            <input {...getInputProps()} disabled={isUploaderDisabled}/>
            <span className="mx-auto flex justify-center">
              <FiUploadCloud className="text-3xl text-towne-blue" />
            </span>
            <p className="text-sm mt-2 dark:text-gray-400">
              {isUploaderDisabled
                ? `You can only upload up to ${maxFiles} images.`
                : `Drag your ${isMultiple ? "images" : "image"} here`}
            </p>
            <em className="text-xs text-gray-400">
              ({t("accepted-file-types-text")})
            </em>
          </div>
        )}
      />
      {warning && !error && (
        <span className="text-sm mt-2 flex items-center text-gray-500">
          <GoAlert /> <span className="ml-2">{warning}</span>
        </span>
      )}
      {error && (
        <span className="text-left flex items-center text-red-400">
          <Error errorName={error} />
        </span>
      )}
      <aside className="flex flex-row flex-wrap mt-4">
        
        {!files[0] && displayServerImage(imageUrls, 0)}

        {imageUrl && !files[0] && (
          <div className="relative mx-2">
        <img
          className="inline-flex border rounded-md border-gray-100 dark:border-gray-600 w-24 max-h-24 p-2"
          src={imageUrl}
          alt="product"
        />
        <span
          className="text-red-400 absolute text-2xl cursor-pointer"
          style={{ top: "-12px", right: "-10px" }}
          onClick={() => removeImageUrl(0)}
        >
          <AiFillCloseCircle />
        </span>
      </div>
        )}

        {files[0] && thumbs}
      </aside>
    </div>
  );
};

export default CustomizeUploader;
